import React, { Component } from 'react';
import injectSheet from 'react-jss';
import ReactQuill from 'react-quill';
import classNames from 'classnames';
import Parser from 'html-react-parser';
import {
  Card, CardBody, Input,
} from 'reactstrap';

const styles = {
  cardContainer: {
    // boxShadow: '2px 2px 17px -7px rgba(0, 0, 0, 0.9)',
    borderRadius: '0.3125rem',
    // marginRight: '2rem',
    marginTop: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    // borderRadius: '0.3125rem',
  },
  card: {
    // minWidth: '37.5rem',
    // maxWidth: '37.5rem',
    borderRadius: '0.3125rem',
    border: 'none',
  },
  inputWrapper: {
    // marginBottom: '1rem',
  },
  cardTitle: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    marginBottom: '0.3125rem',
  },
  titleInput: {
    borderColor: '#E5E7E6',
  },
  tooltip: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#979797',
    marginBottom: '0.3125rem',
  },
  text: {
    minHeight: '11.5rem',
    // maxHeight: '5.5rem',
    resize: 'none',
    borderColor: '#E5E7E6',
  },
  placeHolder: {
    fontFamily: ' Lato, Arial',
    fontSize: '0.875rem',
    color: '#979797',
    display: 'inline-block',
    float: 'right',
  },
  textArea: {
    maxHeight: '19.63rem',
    minHeight: '19.63rem',
    borderRadius: '0.3125rem',
    '& > .ql-toolbar': {
      position: 'absolute',
      border: 'none',
      zIndex: 9,
      boxShadow: '1px 3px 10px -1px rgba(87,73,87,0.49)',
      left: '2rem',
      bottom: '2rem',
      borderRadius: '0.3125rem',
      '& > .ql-formats .ql-picker.ql-expanded .ql-picker-options': {
        marginTop: '-207px',
      },
    },
    '& > .ql-container': {
      position: 'absolute',
      border: 'none',
      width: '93%',
      minHeight: '14.63rem',
      maxHeight: '14.63rem',
    },
  },
  border: {
    border: '1px solid #E5E7E6',
    borderRadius: '3px',
  },
};
class CustomFieldsCard extends Component {

 /* quillSolver(value){
    if(value != undefined){
      console.log(Parser(value))
      return Parser(value)

    }else{
      return value
    }
  } */

  renderCustomField = (classes, type, placeholder, onChange, value, disabled) => {
    switch(type) {
      case 'input':
        return (
          <Input className={classes.titleInput} disabled={disabled} type="input" value={value} name="title" id="title" placeholder={placeholder}/>
        );
      case 'Text':
      return (
        <Input className={classes.text} disabled={disabled} onChange={onChange} value={value} type="textarea" name="textbox" id="text" placeholder={placeholder} />
      )
      case 'quill': 
        return (
        <ReactQuill
          theme="snow"
          defaultValue={value}
          id="quill"
          onChange={onChange}
          className={classes.textArea}
          disabled={disabled}
          placeholder="Add a prompt to this random topic."
        />
        )
    }
  }

  render() {
    const { classes, label, type, tooltip, placeholder, onChange, value, key, disabled } = this.props;
    return (
      <div className={classes.cardContainer} key={key} >
        <Card className={classes.card}>
          <CardBody>
            <div className={classes.cardTitle}>
              {label}
            </div>
            <div className={classes.tooltip}>
              {tooltip}
            </div>
            <div
              className={classNames(classes.inputWrapper, {
                [classes.border]: type === 'quill',
              })}
            >
              {this.renderCustomField(classes, type, placeholder, onChange, value, disabled)}
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default injectSheet(styles)(CustomFieldsCard);



// WEBPACK FOOTER //
// ./src/components/CustomFieldsCard.js